import { useSelector } from 'react-redux'
import { getUsuarioLogado } from '../../auth/AuthStore'
import { useParams } from 'react-router'
import { ConteudoParamsType } from '../../conteudo/Conteudo'
import { CURSOS } from '../cursos'

export interface CustomDataType {
  /**
   * Content of data field. Tags will be insulated
   */
  content?: string
  /**
   * Title shown above a data field
   */
  title?: string
  /**
   * URL that opens when you click on a data field
   */
  link?: string
  /**
   * Description of the data field, bold text before a colon
   */
  key?: string
}

export const useOpenJivoChat = () => {
  const openJivoChat = ({ customData }: { customData?: CustomDataType[] }) => {
    const jivoApi = window.jivo_api
    if (!jivoApi) return
    jivoApi.open()

    jivoApi.setCustomData(customData ?? [])
  }

  return {
    openJivoChat,
  }
}
